/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconBrandFlutter = createReactComponent("outline", "brand-flutter", "IconBrandFlutter", [["path", { "d": "M7 14l-3 -3l8 -8h6z", "key": "svg-0" }], ["path", { "d": "M14 21l-5 -5l5 -5h5l-5 5l5 5z", "key": "svg-1" }]]);

export { IconBrandFlutter as default };
//# sourceMappingURL=IconBrandFlutter.mjs.map
